import { useAccountRepository } from '@frontend/repository';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useReviews = () => {
    const dispatch = useAppDispatch();
    const { currentAccount } = useAccountRepository();
    const navigate = useNavigate();
    const location = useLocation();

    return {
        dispatch,
        currentAccount,
        navigate,
        location
    };
};
